<div class="page-wrapper">

  <!-- Stepper -->
  <app-stepper [currentStep]="2"/>

  <!-- Main layout -->
  <div class="content-layout">

    <!-- Left: Main content -->
    <main class="main-content">
      <h1 class="page-title">Sign Appointment of Agent</h1>
      @if (!(state === 'complete' && documentUrl)) {
        <p class="page-subtitle">
          Review and sign {{ documentName }} to authorize Kin to file your {{ pageTitle }}.
          The form has been prefilled with your information — review it and sign below. Note <strong>after signing
          it might take some time for the page to load the document.
        </strong>
        </p>
      }

      <!-- Document signed card — shown above authorize when complete -->
      @if (state === 'complete') {
        <div class="complete-card card">
          <div class="complete-card-header">
            <div class="complete-card-icon">
              <ngk-icon icon="circle-check" size="1.5rem" color="var(--color-success-600)"/>
            </div>
            <div>
              <p class="complete-card-title">Document signed</p>
              <p class="complete-card-subtitle">Your Appointment of Agent form has been signed successfully.</p>
            </div>
          </div>

          @if (documentUrl) {
            <div class="complete-card-download">
              <ngk-icon icon="file-text" size="1rem" color="var(--color-neutral-500)"/>
              <a class="complete-card-download-link" [href]="documentUrl" download>Download signed document (PDF)</a>
            </div>
          }
        </div>
      }

      <!-- Authorize card — only show full form when not yet signed -->
      @if (state === 'signing') {
        <div class="authorize-card card">
          <div class="authorize-card-header">
            <ngk-icon icon="file-text" size="1.1rem" color="var(--color-neutral-600)"/>
            <p class="authorize-card-title">Authorize your {{ filingNoun }}</p>
          </div>

          <div class="authorize-body">
            <p>
              By clicking the checkbox and the "Sign the Agreement" button below, you affirm that you have read (by
              clicking on and reading each document), understood, and agree with each and are electronically signing
              your <a href="PROPERTY_TAX_CONSULTING_SERVICE_AGREEMENT.pdf" target="_blank">Property Tax Consulting
              Terms</a> and acknowledge your consent to the
              <a href="privacy_notice_kin.pdf" target="_blank">Privacy Notice</a>
              and
              <a href="https://www.kin.com/terms/">Terms of Service</a>.
            </p>
          </div>

          <div class="authorize-duration">
            <p class="authorize-duration-label">Authorization duration</p>
            <label class="duration-option" [class.duration-option--selected]="authorizationDuration === 'one-year'">
              <input type="radio" name="authDuration" value="one-year" [checked]="authorizationDuration === 'one-year'"
                     (change)="onDurationChange('one-year')"/>
              <div class="duration-option-content">
                <span class="duration-option-title">One year</span>
                <span
                  class="duration-option-desc">Authorize Kin to file your {{ filingNoun }} for 2026 tax year only</span>
              </div>
            </label>
            <label class="duration-option" [class.duration-option--selected]="authorizationDuration === 'ongoing'">
              <input type="radio" name="authDuration" value="ongoing"
                     [checked]="authorizationDuration === 'ongoing'" (change)="onDurationChange('ongoing')"/>
              <div class="duration-option-content">
                <span class="duration-option-title">Ongoing</span>
                <span class="duration-option-desc">Authorize Kin to manage your {{ pageTitle }}s every year going forward</span>
              </div>
            </label>
          </div>

          <div class="authorize-checkbox-row">
            <ngk-checkbox [(value)]="authorized">
              <div class="authorize-label">
                <span class="authorize-label-title">I, {{ ownerName }}, authorize Kin to file this {{ pageTitle }} on my behalf</span>
                <p class="authorize-label-desc">I confirm I own {{ addressService.displayStreet }} and understand the
                  10% of savings applies only if my taxes are reduced.</p>
              </div>
            </ngk-checkbox>
          </div>
        </div>
      }

      <!-- Signing document (SDK container / loading) — below authorization -->
      @if (state === 'loading') {
        <div class="loading-container">
          <div class="loading-spinner"></div>
          <p class="loading-text">Preparing your document...</p>
        </div>
      }

      @if (state === 'signing') {
        <div #signingContainer class="signing-container"></div>
      }

      @if (state === 'signing' || state === 'complete') {
        <div class="authorize-card-actions">
          <button ngkButton color="secondary" mode="solid" size="md" [prefixIcon]="'arrow-right'" class="file-btn"
                  [disabled]="!canContinue" (click)="continueToCase()">Continue to Your Case
          </button>
        </div>
      }
      <!-- Error state -->
      @if (state === 'error') {
        <div class="error-container">
          <div class="error-icon">
            <ngk-icon icon="alert-circle" size="2rem" color="var(--color-warning-600)"/>
          </div>
          <p class="error-message">{{ errorMessage }}</p>
          <button ngkButton color="secondary" mode="solid" size="md" (click)="retry()">Try Again</button>
        </div>
      }

      <!-- Back link -->
      <button class="back-link" (click)="back()">← Back</button>
    </main>

    <!-- Right: Sidebar -->
    <app-property-sidebar/>
  </div>
</div>
